import React from "react";

import { SizeClass } from "@/src/common/Utils/SizeClass";
import { WidgetScreenPreviewCompact } from "./WidgetScreenPreviewCompact";
import { WidgetScreenPreviewProps } from "./WidgetScreenPreviewProps";
import { WidgetScreenPreviewRegular } from "./WidgetScreenPreviewRegular";
import { useSizeClass } from "@/src/common/Utils/useSizeClass";

export function WidgetScreenPreview(props: WidgetScreenPreviewProps) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return isCompact ? (
    <WidgetScreenPreviewCompact {...props} />
  ) : (
    <WidgetScreenPreviewRegular {...props} />
  );
}
